/*
 * Projekt:   PBP
 * Modul:     api-component.jsx
 * Exports:   ApiComponent
 * Funktion:  Wrapper für ApiController
 */

import {
  Component,
} from "react";

import ApiController from "CommonComponents/api-controller";
export default class ApiComponent extends Component {
  render() {
    const {
      name,
      url,
      component: Component,
      plainObject,
    } = this.props;
    return (
      <ApiController
        name={name}
        array={!plainObject}
        url={url}
        method="GET"
      >
        <Component {...this.props}/>
      </ApiController>
    );
  }
}
